import { ComposedTheme, createUseStyles } from '@glu/theming';
import registerDefaults from '../themeDefaults';

registerDefaults();

const styles = ({
  accordion: {
    icon: { arrowFill, arrowSize, display },
    transition: { transitionDelay, transitionDuration, transitionTimingFunction },
  },
}: ComposedTheme) => ({
  icon: {
    height: 20,
    width: 20,
    justifyContent: 'center',
    alignItems: 'center',
    transform: 'rotate(-90deg)',
    transition: `transform ${transitionDuration} ${transitionTimingFunction} ${transitionDelay}`,
    '& svg': {
      width: arrowSize,
      height: arrowSize,
      fill: arrowFill,
    },
    display,
  },
  iconRotated: {
    transform: 'rotate(0deg)',
  },
});

export default createUseStyles(styles);
